$( document ).ready(function() {
  $.ajax({
    url: "https://currencyconverter-api.webrexstudio.com/getStoreData?shopUrl=cartersoshkosh.myshopify.com&deleted=false",
    type: 'get',
    datatype: 'json',
    success:function(data){
      countries = data.data.countries;
      $.each(countries,function(key,country){
        if(country.currency == 'USD'){
          usd_rate = country.configuration.manualExchangeRate;
        }
        if(country.currency == 'LBP'){
          lbp_rate = country.configuration.manualExchangeRate;
        }

      })
      $(".money").on("mouseover", function () {
        price_dollar = $(this).text();
        var index = (price_dollar.indexOf("$") != -1 );
        if(index == true)
        {
       

          ws_price_lp = $(this).attr('ws-price');
          console.log('ws_price' + ws_price_lp);
          ws_price_lp = parseFloat(ws_price_lp);
          ws_price_lp = ws_price_lp * lbp_rate * 100 ;
          ws_price_lp = Shopify.formatMoney(ws_price_lp,"L.L.\{\{amount\}\}");
          $( this ).after( '<div class="money_hover_lp"><span class="">'+ ws_price_lp+'</span></div>');

        }
        var index1 = (price_dollar.indexOf("L.L.") != -1 );
        if(index1 == true)
        {
          ws_price = $(this).attr('ws-price');
          ws_price = parseFloat(ws_price);
          ws_price = Math.round(ws_price);
          ws_price = ws_price * usd_rate * 100 ;
      
          ws_price = Shopify.formatMoney(ws_price,"$\{\{amount\}\}");
          $( this ).after( '<div class="money_hover"><span class="">'+ ws_price+'</span></div>');

        }
      })
      .mouseout(function() {
        $( this ).next().remove();
      });
    }
  })
});